<template>
    <div>
        <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
            <div v-if="this.isMobile">
                <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
            </div>
            <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
                {{ this.$store.state.modal.content.title }}
            </div>
            <div v-if="!this.isMobile">
                <Icon name="close" class="c24 pointer" @click="this.close()"/>
            </div>
        </div>

        <div :class="{ 'content py24 m-0': !this.isMobile }">
            <div class="pl24 pr24">
                <div class="d-flex justify-content-between align-items-center mb24">
                    <div>{{ $t('views.P2P.SingleSwap.42') }}</div>
                        <star-rating
                            v-model:rating="this.rating"
                            :show-rating="false"
                            :padding="4"
                            :animate="true"
                            active-color="#FF7F11"
                            :rounded-corners="true"
                            @setRating="setRating"
                            star-size="24"
                        ></star-rating>
                    </div>
                <label class="col-form-label" for="comment">{{ $t('views.P2P.SingleSwap.43') }}</label>
                <textarea class="form-control mb-3" id="comment" v-model="this.rating_comment"></textarea>
            </div>

            <div class="d-flex mt24 pl24 pr24" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
                <Button type="btn-warning" class="equal-width h48 mr16" @click="this.save()">
                    {{ $t('views.P2P.SingleSwap.40') }}
                </Button>
                <Button type="btn-outline-grey" class="equal-width h48 primary-grey" @click="this.close()">
                    {{ $t('views.P2P.SingleSwap.41') }}
                </Button>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon'
import Button from '@/components/service/Button'
import StarRating from 'vue-star-rating';

export default {
    name: 'RatingP2P',
    components: {
        Icon,
        Button,
        StarRating
    },
    props: {
        close: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            rating: 0,
            rating_comment: ''
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768
        }
    },
    mounted() {
        // Получаем данные из content модального окна
        const content = this.$store.state.modal.content;
        if (content.rating !== undefined) {
            this.rating = content.rating;
        }
        if (content.rating_comment !== undefined) {
            this.rating_comment = content.rating_comment;
        }
    },
    methods: {
        setRating(rating) {
            this.rating = rating;
        },
        save() {
            // Вызываем callback с данными рейтинга
            const content = this.$store.state.modal.content;
            if (content.callback) {
                content.callback(this.rating, this.rating_comment);
            }
            this.close();
        }
    }
}
</script>
